module.exports = __webpack_public_path__ + "media/stop_bet.4869f5ea.mp3";